import inView from 'in-view';
import Helper from '../../lib/Helper';

export default {
	_selectorStory        : '[data-story]',
	_selectorSlide        : '[data-story-slide]',
	_selectorBG           : '[data-story-bg]',
	_selectorCard         : '[data-story-card]',
	_selectorButton       : '[data-story-button]',
	_selectorModal        : '[data-story-modal]',
	_selectorModalInner   : '[data-story-modal-inner]',
	_selectorModalContents: '[data-story-modal-contents]',
	_selectorModalClose   : '[data-story-modal-close]',
	_activeClassBG        : 'story__background--active',
	_activeClassButton    : 'story__button--active',
	_activeClassModal     : 'story__modal--active',
	_bgElements           : [],
	init() {
		const story = document.querySelector(this._selectorStory);
		if (!story) {
			return;
		}
		this._initDOM();
		this._initSlides();
		this._initBGs();
		this._initButtons();
	},
	_disableBG(element) {
		const bg = element.querySelector(this._selectorBG);
		if (!bg) {
			return;
		}
		bg.classList.remove(this._activeClassBG);
		const video = element.querySelector('.video__video--story');
		if (!video) {
			return;
		}
		this._stopVideo(video);
	},
	_enableBG(element) {
		const bg = element.querySelector(this._selectorBG);
		if (!bg) {
			return;
		}
		bg.classList.add(this._activeClassBG);
		const video = element.querySelector('.video__video--story');
		if (!video) {
			return;
		}
		this._startVideo(video);
	},
	_enableButton(slide) {
		const button = slide.querySelector(this._selectorButton);
		if (!button) {
			return;
		}
		button.classList.add(this._activeClassButton);
	},
	_disableButton(slide) {
		const button = slide.querySelector(this._selectorButton);
		if (!button) {
			return;
		}
		button.classList.remove(this._activeClassButton);
	},
	_enableSlide(slide) {
		this._enableBG(slide);
		this._enableButton(slide);
	},
	_disableSlide(slide) {
		this._disableBG(slide);
		this._disableButton(slide);
	},
	_initSlides() {
		const slides = document.querySelectorAll(this._selectorSlide);
		if (!slides.length) {
			return;
		}
		inView(this._selectorCard).on('enter', element => {
			const slide = document.querySelector(`[data-story-slide='${element.getAttribute('data-story-card')}']`);
			this._enableSlide(slide);
		}).on('exit', element => {
			const slide = document.querySelector(`[data-story-slide='${element.getAttribute('data-story-card')}']`);
			this._disableSlide(slide);
		});
	},
	_onSrcChange(e) {
		e.path[3].style.backgroundImage = `url('${e.path[0].currentSrc}')`;
	},
	_stopVideo(video) {
		video.pause();
		video.currentTime = 0;
	},
	_startVideo(video) {
		video.play();
	},
	_initBGs() {
		this._bgElements = document.querySelectorAll(this._selectorBG);
		if (!this._bgElements.length) {
			return;
		}
		Array.prototype.forEach.call(this._bgElements, element => {
			const video = element.querySelector('.video__video--story');
			if (video) {
				this._stopVideo(video);
			}
		});
	},
	_onModalInnerClicked(e) {
		Helper.haltEvent(e);
	},
	_showModal(e) {
		Helper.haltEvent(e);
		const button       = e.target;
		const footnote     = document.querySelector(`[data-story-footnote='${button.getAttribute('data-story-button')}']`);
		const modal        = document.querySelector(this._selectorModal);
		const inner        = modal.querySelector(this._selectorModalInner);
		const contents     = modal.querySelector(this._selectorModalContents);
		const closeToggles = modal.querySelectorAll(this._selectorModalClose);
		Array.prototype.forEach.call(closeToggles, toggle => {
			toggle.removeEventListener('click', this._hideModal.bind(this));
			toggle.addEventListener('click', this._hideModal.bind(this));
		});
		inner.removeEventListener('click', this._onModalInnerClicked.bind(this));
		inner.addEventListener('click', this._onModalInnerClicked.bind(this));
		modal.removeEventListener('click', this._hideModal.bind(this));
		modal.addEventListener('click', this._hideModal.bind(this));
		contents.innerHTML = footnote.innerHTML;
		modal.classList.add(this._activeClassModal);
	},
	_hideModal(e) {
		Helper.haltEvent(e);
		const modal = document.querySelector(this._selectorModal);
		modal.classList.remove(this._activeClassModal);
	},
	_initButtons() {
		const buttons = document.querySelectorAll(this._selectorButton);
		if (!buttons.length) {
			return;
		}
		const modal = document.querySelector(this._selectorModal);
		if (!modal) {
			Array.prototype.forEach.call(buttons, button => {
				button.parentNode.removeChild(button);
			});
			return;
		}
		Array.prototype.forEach.call(buttons, button => {
			const footnote = document.querySelector(`[data-story-footnote='${button.getAttribute('data-story-button')}']`);
			if (!footnote) {
				button.parentNode.removeChild(button);
			} else {
				button.addEventListener('click', this._showModal.bind(this));
			}
		});
	},
	_initDOM() {
		const header         = document.querySelector('[data-header]');
		const footer         = document.querySelector('[data-footer]');
		header.style.display = 'none';
		footer.style.display = 'none';
	}
};